import { render, staticRenderFns } from "./PurchasePlanListDetail.vue?vue&type=template&id=7ab58646&scoped=true&"
import script from "./PurchasePlanListDetail.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanListDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanListDetail.vue?vue&type=style&index=0&id=7ab58646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab58646",
  null
  
)

export default component.exports